import { PropTypes } from "prop-types"
import classNames from "classnames"

import Translate from "../Translate"
import Button from "../Button"
import OptionPlusMinusLabel from "./OptionPlusMinusLabel"

export function OptionPlusMinus(props) {
  const {
    className,
    children,
    labelId,
    value,
    onRemove,
    onAdd,
    ariaLabelButtonDecrease = "accessOptionDecrease",
    ariaLabelButtonIncrease = "accessOptionIncrease",
    ariaLabelTotal = "accessOptionQuantitySelected",
    max = 5,
    min = 0
  } = props

  const enabledMinus = value > min
  const enabledPlus = value < max

  const handleMinusClick = e => {
    e.preventDefault()

    onRemove(value - 1)
  }

  const handlePlusClick = e => {
    e.preventDefault()

    onAdd(value + 1)
  }

  const handleKeyDown = e => {
    if (["ArrowUp", "ArrowDown", "Home", "End"].includes(e.key)) {
      if (e.key === "ArrowUp") {
        if (enabledPlus) {
          onAdd(value + 1)
        }
      } else if (e.key === "ArrowDown") {
        if (enabledMinus) {
          onRemove(value - 1)
        }
      } else if (e.key === "Home") {
        onRemove(min)
      } else {
        // key will be "End"
        onAdd(max)
      }

      e.preventDefault()
      e.stopPropagation()
    }
  }

  return (
    <Translate>
      {({ translate }) => (
        <div className={classNames("oj-option-plus-minus", className)} role="group">
          {children}
          <div
            className="spin-button"
            role="spinbutton"
            tabIndex={0}
            aria-valuenow={value}
            aria-valuetext={translate(`${ariaLabelTotal}${value > 1 ? "Plural" : ""}`, { value })}
            aria-valuemin={min}
            aria-valuemax={max}
            aria-labelledby={labelId}
            onKeyDown={handleKeyDown}
          >
            <Button
              className="minus"
              disabled={!enabledMinus}
              ariaLabel={translate(ariaLabelButtonDecrease)}
              tabIndex={-1}
              onClick={handleMinusClick}
            />
            <span className="total-num">{value}</span>
            <Button
              className="plus"
              disabled={!enabledPlus}
              ariaLabel={translate(ariaLabelButtonIncrease)}
              tabIndex={-1}
              onClick={handlePlusClick}
            />
          </div>
        </div>
      )}
    </Translate>
  )
}

OptionPlusMinus.propTypes = {
  ariaLabelTotal: PropTypes.string,
  ariaLabelButtonIncrease: PropTypes.string,
  ariaLabelButtonDecrease: PropTypes.string,
  className: PropTypes.string,
  children: PropTypes.node.isRequired,
  labelId: PropTypes.string.isRequired,
  max: PropTypes.number,
  min: PropTypes.number,
  value: PropTypes.number.isRequired,
  onAdd: PropTypes.func.isRequired,
  onRemove: PropTypes.func.isRequired
}

OptionPlusMinus.Label = OptionPlusMinusLabel

export default OptionPlusMinus
